import { useMemo } from 'react'
import { getFeatureFromCache } from '../../../../util/feature-cache'
import { useRetailerSettingsManager } from '../../../../ng-compat/hooks'
import { hasServiceOrder } from '../../../../functions/service'
import {
  isLegacyServiceSale,
  isMarkedAsUnfulfilled,
  isPartialPaidSale,
  isUnpaidSale,
} from '../../../../functions/sale'
import { useAppSelector } from '../../../../state/hooks'
import { selectCurrentSale } from '../../../../state/slices/currentSale/currentSaleSlice'

/**
 * Determine if the Save Sale button for unfulfilled sales / service should be shown ~ to allow
 * for partially paid unfulfilled sales.
 *
 * @return {Boolean} true if the save sale button should be visible, false otherwise
 */
export function useShowSaveSaleButton() {
  const sale = useAppSelector(selectCurrentSale)
  const hasQboEnabled = getFeatureFromCache('has_qbo')
  const shouldIgnoreAccountingIntegrations = getFeatureFromCache(
    'pufs_ignore_accounting_integrations'
  )

  const retailerSettingsManager = useRetailerSettingsManager()
  const hasXeroEnabled = retailerSettingsManager.isXeroIntegrationEnabled()

  const hasAccountingIntegrations = useMemo(() => {
    return hasXeroEnabled || hasQboEnabled
  }, [hasXeroEnabled, hasQboEnabled])

  const isBlockedByAccountingIntegrations = shouldIgnoreAccountingIntegrations
    ? false
    : hasAccountingIntegrations

  const saleHasServiceOrder = hasServiceOrder(
    sale.serviceFields,
    sale.customFields
  )

  const hideSaveBtnForServices =
    saleHasServiceOrder &&
    !isLegacyServiceSale(sale.status) &&
    !isMarkedAsUnfulfilled(sale.status)

  return [
    Boolean(
      !isBlockedByAccountingIntegrations &&
        (isPartialPaidSale(sale) || isUnpaidSale(sale)) &&
        !hideSaveBtnForServices
    ),
  ]
}
